import { render, staticRenderFns } from "./TableWidgetPanel.vue?vue&type=template&id=665cbe31&scoped=true"
import script from "./TableWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TableWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TableWidgetPanel.vue?vue&type=style&index=0&id=665cbe31&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665cbe31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665cbe31')) {
      api.createRecord('665cbe31', component.options)
    } else {
      api.reload('665cbe31', component.options)
    }
    module.hot.accept("./TableWidgetPanel.vue?vue&type=template&id=665cbe31&scoped=true", function () {
      api.rerender('665cbe31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TableWidgetPanel.vue"
export default component.exports